import { render, staticRenderFns } from "./PassengerInfo.vue?vue&type=template&id=4747fb04&scoped=true&"
import script from "./PassengerInfo.vue?vue&type=script&lang=ts&"
export * from "./PassengerInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PassengerInfo.vue?vue&type=style&index=0&id=4747fb04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4747fb04",
  null
  
)

export default component.exports